import { render, staticRenderFns } from "./StopScreeningModal.vue?vue&type=template&id=0fe5526a&"
import script from "./StopScreeningModal.vue?vue&type=script&lang=js&"
export * from "./StopScreeningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports